import Login from '../views/login'
import Main from '../views/main'

// 不需要权限控制的路由
const baseRouter = [
  {
    path: '/',
    // name: 'login',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/main',
    component: Main,
    redirect: '',
    title: '',
    icon: '',
    children: [
      {
        path: '/welcome',
        component: () => import('@/views/welcome/index'),
        name: 'welcome',
        title: '欢迎页',
        icon: ''
      },
      {
        path: '/role',
        component: () => import('../views/role/index'),
        name: 'role',
        title: '权限',
        icon: ''
      }
    ]
  }
]
export default baseRouter
